import { useTranslation } from 'react-i18next';
import { Alert, Button, Modal, ModalActions, ModalContent, ModalTitleInfo } from '@c2fo/liquidity';
import { TypingIcon } from '@c2fo/liquidity/icons';

interface FinalApprovalModalProps {
  isFinalApprovalModalOpen: boolean;
  setIsFinalApprovalModalOpen: (open: boolean) => void;
  onFinalApproval: () => void;
  isSubmittingDraftOffer: boolean;
  isSubmitError?: boolean;
  isAgreementsErrorNotChecked?: boolean;
}

const FinalApprovalModal = ({
  isFinalApprovalModalOpen,
  setIsFinalApprovalModalOpen,
  onFinalApproval,
  isSubmittingDraftOffer,
  isSubmitError,
  isAgreementsErrorNotChecked,
}: FinalApprovalModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal open={isFinalApprovalModalOpen} onClose={() => setIsFinalApprovalModalOpen(false)} size="sm">
      <ModalTitleInfo>{t('draftOffer.finalApproval')}</ModalTitleInfo>
      <ModalContent center>
        <TypingIcon className="h-24 w-auto lg:block" />
        <p className="text-left">{t('draftOffer.confirmation.body.preferred')}</p>
        {isSubmitError && <Alert type="error" variant="filled" description={t('draftOffer.error')} full />}
        {isAgreementsErrorNotChecked && (
          <Alert type="error" variant="filled" description={t('agreements.error.checkbox')} full />
        )}
      </ModalContent>
      <ModalActions>
        <Button variant="secondary" onClick={() => setIsFinalApprovalModalOpen(false)}>
          {t('core.cancel')}
        </Button>
        <Button
          variant="cta"
          onClick={onFinalApproval}
          loading={isSubmittingDraftOffer}
          disabled={isSubmittingDraftOffer}
        >
          {t('draftOffer.approve')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default FinalApprovalModal;
